import { Link } from "react-router-dom";
import PageMeta from "@/components/PageMeta";
import BreadcrumbJsonLd from "@/components/BreadcrumbJsonLd";
import { EvernoteGuideSteps, GUIDE_STEPS } from "@/components/EvernoteGuide";

const HOWTO = {
  "@context": "https://schema.org",
  "@type": "HowTo",
  name: "How to import Evernote notebooks into RecipeFiler",
  step: GUIDE_STEPS.map((s, i) => ({ "@type": "HowToStep", position: i + 1, name: s.title, text: s.body })),
};

export default function EvernoteImportHelp() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12" data-testid="evernote-help-page">
      <PageMeta
        title="How to import Evernote notebooks — step-by-step guide"
        description="Export your Evernote notebooks as .enex files and bring every recipe into RecipeFiler, with photos, tags as categories, duplicate checks and one cookbook per notebook."
        canonical="https://recipefiler.com/help/evernote-import"
      />
      <BreadcrumbJsonLd items={[
        { name: "Home", url: "https://recipefiler.com/" },
        { name: "Import", url: "https://recipefiler.com/import" },
        { name: "Evernote import guide", url: "https://recipefiler.com/help/evernote-import" },
      ]} />
      {/* eslint-disable-next-line react/no-danger */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(HOWTO) }} />
      <p className="overline mb-2">Help</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-rf-ink leading-tight">Importing from Evernote, step by step</h1>
      <p className="mt-4 text-slate-600">Move all your Evernote recipe notes, with photos and tags, into tidy cookbooks in a few minutes.</p>
      <div className="mt-10"><EvernoteGuideSteps /></div>
      <Link to="/import?tab=file" className="btn-amber inline-flex mt-10" data-testid="evernote-help-start">Start your Evernote import</Link>
    </div>
  );
}
